import { Stack, Typography, ClickAwayListener, Tooltip, IconButton } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Markdown } from '@cibo/ui'

export const CarbonFootprintHeader = () => {
  const { t } = useTranslation('@cibo/landmanager/LandReport/CarbonFootprint')
  const [showTooltip, setShowTooltip] = useState(false)
  return (
    <Stack direction="row" alignItems="center">
      <Typography variant="subtitle1">{t('carbonEmissions')}</Typography>
      <ClickAwayListener onClickAway={() => setShowTooltip(false)}>
        <div>
          <Tooltip
            title={<Markdown>{t('carbonEmissionsInfo')}</Markdown>}
            open={showTooltip}
            onClose={() => setShowTooltip(false)}
            disableHoverListener
            disableFocusListener
            disableTouchListener
          >
            <IconButton
              onClick={e => {
                e.stopPropagation()
                setShowTooltip(!showTooltip)
              }}
              size="small"
              color="secondary"
            >
              <HelpOutlineIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </div>
      </ClickAwayListener>
    </Stack>
  )
}
